import { render, staticRenderFns } from "./TooltipContenido.vue?vue&type=template&id=3bea05b4"
import script from "./TooltipContenido.vue?vue&type=script&lang=js"
export * from "./TooltipContenido.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports